import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  import React from "react";
  
  const development = {
    label: "Development Module",
    pageLabel: "Development Module",
    starting: true,
    url: "development",
    pageType: "history",
    formTabs: {
      allTabs: [
        {
          label: "General",
          uid: "create",
          style: { fontFamily: "verdana" }
        }
      ]
    },
  
    filter:[
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'filter',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getCircleName",
            fieldType: "string",
            filters: ["pageData", "circlename"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Circle",
        name: "circle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Sub Circle",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'filter',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getSubCircleName",
            fieldType: "string",
            filters: ["pageData", "subcirclename"],
            dependsOn:[{circle:"circle.value"}]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Sub Circle",
        name: "subCircle",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Work Date",
        description: ""
      },
      {
          inputType: "date",
          dateType: "ontype",
          tab:'filter',
          isRequired: true,
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "Work Date",
          displayFormat: "DD/MM/YYYY",
          outputFormat: "YYYYMMDD",
          name: "workdate",
          description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-6",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Work Status",
        description: ""
      },
      {
          inputType: "select",
          tab:'filter',
          default: "",
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [
            {
              label: "Completed",
              value: "completed"
            },
            {
              label: "In Progress",
              value: "inProgress"
            },
            {
              label: "Not Completed",
              value: "notCompleted"
            },
            {
              label: "Stop",
              value: "stop"
            },
                            
          ],
          placeHolder: "Work Status",
          name: "workstatus",
          description: ""
         },
         {
          inputType: "displaytext",
          tab:'filter',
          widths: {
            parent: "col-lg-6",
            children: "col-lg-12"
          },
          label: "",
          description: ""
        },
        {
          inputType: "displaytext",
          tab:'filter',
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "No Of Records",
          description: ""
        },
        {
          inputType: "numberonly",
          tab:'filter',
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "",
          placeHolder: "Per Page",
          name: "per_page",
          description: ""
        },
    ],

    form: [
        {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Circle",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getCircleName",
                fieldType: "string",
                filters: ["pageData", "circlename"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Circle",
            name: "circle",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Sub Circle",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getSubCircleName",
                fieldType: "string",
                filters: ["pageData", "subcirclename"],
                dependsOn:[{circle:"circle.value"}]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Sub Circle",
            name: "subCircle",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Village",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVillageEle",
                fieldType: "string",
                filters: ["pageData", "VillageEle"],
                dependsOn:[{circle:"circle.value"},{subCircle:"subCircle.value"}]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Village",
            name: "village",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Work Date",
            description: ""
          },
          {
              inputType: "date",
              dateType: "ontype",
              tab:'create',
              isRequired: true,
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Work Date",
              displayFormat: "DD/MM/YYYY",
              outputFormat: "YYYYMMDD",
              name: "workdate",
              description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Work Type",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getWorkTypeEle",
                fieldType: "string",
                filters: ["pageData", "WorkTypeEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Work Type",
            name: "workType",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Scheme",
            description: ""
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getSchemeEle",
                fieldType: "string",
                filters: ["pageData", "SchemeEle"],
                dependsOn:[{workType:"workType.value"}]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Scheme",
            name: "scheme",
            description: ""
          },
          {
            inputType: "displaytext",
            // 
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Details of Work",
            description: ""
          },   
          {
            inputType: "text",
            tab:'create',
            widths: {
              parent: "col-lg-10",
              children: "col-lg-12"
            },
            placeHolder: "Details of Work",
            name: "detailsofWork",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Proposed Cost",
            description: ""
          },
          {
            inputType: "numberonly",
            tab:'create',
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Proposed Cost",
            name: "proposedcost",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Sanctioned Cost",
            description: ""
          },
          {
            inputType: "numberonly",
            tab:'create',
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Sanctioned Cost",
            name: "sanctionedcost",
            description: ""
          },
          {
            inputType: "displaytext",
            // 
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Contractor Name",
            description: ""
          },   
          {
            inputType: "text",
            tab:'create',
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Contractor Name",
            name: "contractorname",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Mobile Number",
            description: ""
          },
          {
            inputType: "numberonly",
            tab:'create',
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Mobile Number",
            name: "mobilenumber",
            description: ""
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Work Status",
            description: ""
          },
          {
              inputType: "select",
              tab:'create',
              default: "",
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [
                {
                  label: "Completed",
                  value: "completed"
                },
                {
                  label: "In Progress",
                  value: "inProgress"
                },
                {
                  label: "Not Completed",
                  value: "notCompleted"
                },
                {
                  label: "Stop",
                  value: "stop"
                },
                                
              ],
              placeHolder: "Work Status",
              name: "workstatus",
              description: ""
             },
         
            {
                inputType: "fileupload",
                tab:'create',
                widths: {
                  parent: "col-lg-6",
                  children: "col-lg-12"
                },
                label: "Attachment",
                name: "attachment",
                placeholder: {
                  type: "text",
                  value:
                    "Attachment"
                },
                files: [],
                multiple: true
                
            },
            

         
    ],
    history: {
      perPage: 10,
      displayColumns: [
        {
          Header: "Circle",
          accessor: "circle.value",
          // Cell: ({ value }) => (value >= 21 ? "Ahmedpur" : "Ahmedpur"),
          // filterMethod: (filter, row) => {
          //   if (filter.value === "all") {
          //     return true;
          //   }
          //   if (filter.value === "true") {
          //     return row[filter.id] >= 21;
          //   }
          //   return row[filter.id] < 21;
          // },
          // Filter: ({ filter, onChange }) =>
          //           <select
          //             onChange={event => onChange(event.target.value)}
          //             style={{ width: "100%" }}
          //             value={filter ? filter.value : "all"}
          //           >
          //             <option value="all">Show All</option>
          //             <option value="true">Can Drink</option>
          //             <option value="false">Can't Drink</option>
          //           </select>
        },
        {
          Header: "Sub Circle",
          accessor: "subCircle.value",
        },
        {
          Header: "Village",
          accessor: "village.value",
        },
        {
          Header: "Work Date",
          accessor: "workdate.label",
        },
        {
          Header: "Work Type",
          accessor: "workType.value",
        },
        {
          Header: "Scheme",
          accessor: "scheme.value",
        },
        {
          Header: "Details of Work",
          accessor: "detailsofWork",
        },
        {
          Header: "Proposed Cost",
          accessor: "proposedcost",
        },
        {
          Header: "Sanctioned Cost",
          accessor: "sanctionedcost",
        },
        {
          Header: "Work Status",
          accessor: "workstatus",
        },
              
        
      ]
    },
  report: {
      perPage: 10,
      queryType: "mysqlQuery",
      //   groupBy: ["schedule","subschedule"],
      query: [
        {
          dialect: "mysql",
          seq: 1,
          columnHeader: [
            {
              id: "balance1",
              headerText: "trdate",
              headerFrom: "balance"
            }
          ],
          query: ""
        }
      ],
      displayColumns: [
        {
          Header: "Village",
          accessor: "village.value",
        },
        {
          Header: "Work Date",
          accessor: "workdate.label",
        },
        {
          Header: "Work Type",
          accessor: "worktype.value",
        },
        {
          Header: "Scheme",
          accessor: "scheme.value",
        },
        {
          Header: "Proposed Cost",
          accessor: "proposedcost",
        },
        {
          Header: "Sanctioned Cost",
          accessor: "sanctionedcost",
        },
        
      ]
    }
  }
  export default development;